import { CustomTextService } from './services/custom_text_service';
import { AppointmentSchedulingServant } from './servants/appointment_scheduling_servant';
import { CustomContentsServant } from './servants/custom_contents_servant';
import { ReportConfigService } from './services/report_config_service';
export { ReportConfigService } from './services/report_config_service';

angular
  .module('data-ng-custom-text', [])
  .service('ngCustomTextService', CustomTextService)
  .service('ngCustomContentsServant', CustomContentsServant)
  .service('ngAppointmentSchedulingServant', AppointmentSchedulingServant)
  .service('ngReportConfigService', ReportConfigService);

require('./commands/load_all_custom_text_command');
require('./commands/load_stc_custom_contents_command');
require('./commands/load_stc_schedule_config_command');
require('./commands/load_appt_summary_config_command');
require('./commands/load_hand_raise_config_command');
require('./commands/load_notes_config_command');
require('./commands/load_progress_reports_config_command');
require('./commands/get_schedule_appointment_label_command');
require('./commands/get_scheduling_config_command');
require('./models/stc_custom_contents_model');
require('./models/stc_scheduling_config_model');
require('./models/custom_text_model');
require('./models/appt_summary_config_model');
require('./models/hand_raise_config_model');
require('./models/notes_config_model');
require('./models/progress_reports_config_model');
require('./queries/custom_text_query');
require('./queries/report_configs_query');
require('./servants/custom_contents_servant');
require('./services/custom_text_service');
require('./services/report_config_service');

export * from './services/custom_text_service';
export * from './services/report_config_service';
export * from './servants/custom_contents_servant';
export * from './servants/appointment_scheduling_servant';
export * from './models/custom_text_model';
export * from './models/stc_custom_contents_model';
export * from './models/stc_scheduling_config_model';
export * from './models/appt_summary_config_model';
export * from './models/hand_raise_config_model';
export * from './models/notes_config_model';
export * from './models/progress_reports_config_model';
export * from './queries/custom_text_query';
export * from './queries/report_configs_query';
export * from './custom_text_interface';



// WEBPACK FOOTER //
// ./app/vendor/data-ng-custom-text/src/main.ts